"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ShieldCheck, Cpu, Wind, FileCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const modules = [{
  title: "Bull & Motion Base",
  note: "Check the individual product listing for included equipment.",
  icon: ShieldCheck
}, {
  title: "Operator Controller",
  note: "Check the individual product listing for included equipment.",
  icon: Cpu
}, {
  title: "Safety Arena & Blower",
  note: "Check the individual product listing for included equipment.",
  icon: Wind
}, {
  title: "Accessories & Documentation",
  note: "Check the individual product listing for included equipment.",
  icon: FileCheck
}];
export default function Inclusions() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.06
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: shouldReduceMotion ? 1 : 0,
      y: shouldReduceMotion ? 0 : 12
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.45,
        ease: "easeOut"
      }
    }
  };
  return <section id="what-comes-with-a-new-bull" data-nav="light" className="relative bg-background py-16 sm:py-20 lg:py-24 border-b border-border">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Enclosing structural hairline wrapper */}
        <div className="border border-border bg-card/60 p-6 sm:p-10 lg:p-14 shadow-xs">
          {/* Header & Meta classification */}
          <div className="max-w-3xl">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight text-foreground leading-[1.05]">
              What Comes With a New Mechanical Bull?
            </h2>

            <div className="mt-6 space-y-4 font-sans text-base text-muted-foreground leading-relaxed">
              <p>
                The advertised price only becomes useful once you understand
                what is included with the machine. A complete package may
                contain the bull body, motion base, controller, inflatable safety
                area, blower, cables and other accessories, while another machine
                may be configured differently.
              </p>
              <p>
                Before making an enquiry, check the individual product page for
                the equipment supplied with that exact model. If something is not
                shown as included, do not assume that it comes with the package.
              </p>
              <p>
                This makes it much easier to compare two mechanical bulls fairly,
                especially when their headline prices are similar but their
                equipment packages are different.
              </p>
            </div>
          </div>

          {/* Precision 4-Card Module Grid */}
          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true,
          amount: 0.2
        }} className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {modules.map((item, index) => {
            const IconComponent = item.icon;
            return <motion.div key={item.title} data-index={index} variants={cardVariants} className="h-full">
                  <Card className="h-full rounded-none border border-border bg-card p-6 shadow-xs flex flex-col justify-between transition-[border-color,box-shadow] duration-200 hover:border-primary">
                    <div>
                      <div className="pb-4 border-b border-border mb-5">
                        <IconComponent className="size-4 text-primary" />
                      </div>
                      <CardHeader className="p-0 gap-0">
                        <CardTitle className="font-serif text-xl sm:text-2xl font-bold uppercase tracking-tight text-foreground leading-snug">
                          {item.title}
                        </CardTitle>
                      </CardHeader>
                    </div>

                    <CardContent className="p-0 pt-6 mt-4 border-t border-border/60">
                      <p className="font-sans text-xs text-muted-foreground leading-relaxed">
                        {item.note}
                      </p>
                    </CardContent>
                  </Card>
                </motion.div>;
          })}
          </motion.div>
        </div>
      </div>
    </section>;
}